import { createContext, useContext } from 'react';

import { IEstimateInformationContext } from '@widgets/EstimateInformation/model/types/types';

export const EstimateInformationContext = createContext<IEstimateInformationContext | null>(null);
export const useEstimateInformation = () => useContext(EstimateInformationContext);
